import React, { useState, useRef, useContext, useEffect } from "react";
import { Formik, Field } from "formik";
import { setOldFileName, manageMapperStore } from "../../../contexts";
import { get, isEmpty } from "lodash";
import {
  FTPDetails,
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputNumber,
  FieldInputPassword,
  FieldInputSSN,
  SearchableList,
  Select,
  UploadComponent,
} from "../../../components";
import {
  required,
  fileFormatData,
  PassthorughfileFormatData,
  yesNoOptions,
} from "../../../utils";
import { useDeepEffect } from "../../../abstracts";
import { Form } from "react-bootstrap";

const isValidSheetNumber = /^\d{1,7}$/;
const isValidSheetName = /^\s+|\s+$|^.{0,33}$/;
function validateInput(input) {
  const trimmedInput = input.trim();
  if (trimmedInput === "") {
    return true;
  } else {
    return false;
  }
}
const SelectDataFromData = [
  {
    label: "First Sheet",
    value: 1,
  },
  {
    label: "Last Sheet",
    value: 2,
  },
  {
    label: "Sheet Number",
    value: 3,
  },
  {
    label: "Sheet Name",
    value: 4,
  },
];
function FileInfo(props) {
  const {
    handleChange,
    values,
    setFileUploadRequired,
    setFieldValue,
    fields,
    isEdit,
    editable,
    fileUploadRequired,
    state,
    isSubmitsucces,
    formName,
    previousFile,
    setPreviousFile,
    newFile,
    fileName,
    setNewFile,
    clearField,
    setClearField,
    setAllowEmptyInputFile,
    allowEmptyInputFile,
  } = props;
  const onChangeFileFormat = () => {
    if (values[fields.fileFormat] == 3) {
      setFieldValue(fields.selectDataFrom, 1);
    }
  };
  const { dispatch } = useContext(manageMapperStore);
  const [showFileName, setShowFileName] = useState(true);
  useDeepEffect(() => {
    if (!isEmpty(fileName) && !isEmpty(newFile)) {
      setShowFileName(false);
    }
  }, [newFile]);
  useDeepEffect(() => {
    setPreviousFile(
      values["fileName"]
        ? values["fileName"]
        : get(state, "api.data.fileName", [])
    );
  }, []);
  useDeepEffect(() => {
    if (isSubmitsucces === false) {
      setFieldValue("fileName", previousFile);
    }
  }, [isSubmitsucces]);
  const clearUploadFile = () => {
    if (
      clearField === false &&
      get(state, "api.fileuploadData.mappingConfiguration.fileName", null)
    ) {
      dispatch(
        setOldFileName({
          fileName: previousFile,
        })
      );
    }
  };
  const ExcelComponent = () => {
    return (
      <div>
        <Field
          name={fields.selectDataFrom}
          label={"Select Data from"}
          value={values[fields.selectDataFrom]}
          options={SelectDataFromData}
          isRequired
          direction={"bottom"}
          //disabled={editable}
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          popupContent={
            <SearchableList
              label={"Select Data from"}
              isNotTypeAhead
              options={SelectDataFromData}
              onSelect={(value) => {
                setFieldValue(fields.selectDataFrom, value);
                setFieldValue(fields.spreadSheetName, "");
                setFieldValue(fields.spreadSheetNumber, "");
              }}
              selectedValue={values[fields.selectDataFrom]}
            />
          }
          component={FieldDropSide}
        />

        {values[fields.selectDataFrom] == SelectDataFromData[2].value && (
          <Field
            name={fields.spreadSheetNumber}
            placeholder={SelectDataFromData[2].label}
            label={SelectDataFromData[2].label}
            noLabelTransform
            component={FieldInput}
            onChange={handleChange}
            type="number"
            validate={(value) => {
              return [undefined, null, ""].includes(value)
                ? "Required"
                : isValidSheetNumber.test(value) === false
                ? "Sheet Number should not be greater than 7 characters"
                : undefined;
            }}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            value={values[fields.spreadSheetNumber]}
            onKeyPress={(e) => {
              // Prevent the input of decimal point
              if (
                e.key === "." ||
                e.key === "e" ||
                (e.key === "-" && e.target.value !== "")
              ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text/plain");
              if (
                pastedData.includes("e") ||
                pastedData.includes(".") ||
                pastedData.includes("-")
              ) {
                e.preventDefault(); // Prevent the paste action if it exceeds 250 characters
              }
            }}
            isRequired
          />
        )}

        {values[fields.selectDataFrom] == SelectDataFromData[3].value && (
          <Field
            name={fields.spreadSheetName}
            placeholder={SelectDataFromData[3].label}
            label={SelectDataFromData[3].label}
            noLabelTransform
            component={FieldInput}
            // disabled={isEdit || !isEmpty(get(state, formName, []))}

            validate={(value) => {
              return [undefined, null, ""].includes(value.trim())
                ? "Required"
                : validateInput(value.trim())
                ? "Required"
                : isValidSheetName.test(value.trim()) === false
                ? "Sheet Name should not be greater than 33 characters"
                : undefined;
            }}
            value={values[fields.spreadSheetName]}
            isRequired
            // onInput={(e) => {
            //   const inputValue = e.target.value.toString();
            //   if (inputValue.length > 33) {
            //     e.target.value = inputValue.slice(0, 33);
            //   }
            // }}
            // onKeyPress={(e)=>{
            //   const inputValue = e.target.value.toString();
            //   if (inputValue.length > 33) {
            //     e.preventDefault();
            //   }
            // }}
            // onPaste={(e) => {
            //   const pastedData = e.clipboardData.getData("text/plain");
            //   if (pastedData.length > 33) {
            //     e.preventDefault(); // Prevent the paste action if it exceeds 250 characters
            //   }
            // }}
          />
        )}
      </div>
    );
  };

  const CSVComponent = () => {
    return (
      <div>
        <div
          style={{ color: "#828282", fontSize: "12px" }}
          className="form-group mb-3"
        >
          <Field
            name={fields.delimiter}
            placeholder={"Delimiter"}
            label={"Delimiter"}
            value={values[fields.delimiter]}
            noLabelTransform
            component={FieldInput}
            validate={(value) => {
              return [undefined, null, ""].includes(value.trim())
                ? "Required"
                : undefined;
            }}
            isRequired
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
          />
        </div>
        <Field
          isRequired
          name={fields.hasHeader}
          label="Has Header"
          size="sm"
          options={yesNoOptions}
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          //disabled={editable}
          onChange={(value) => {
            setFieldValue(fields.hasHeader, value);
          }}
          selectedValue={values[fields.hasHeader]}
          component={FieldButtonGroup}
        />

        {!values[fields.hasHeader] && (
          <Field
            isRequired
            name={fields.checkForHeaderCountMismatch}
            label="Check for Header Count Mismatch"
            size="sm"
            options={yesNoOptions}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            onChange={(value) => {
              setFieldValue(fields.checkForHeaderCountMismatch, value);
            }}
            selectedValue={values[fields.checkForHeaderCountMismatch]}
            component={FieldButtonGroup}
          />
        )}
        {/* <br /> */}
        <div className="form-group">
          <Field
            type="number"
            name={fields.contentStartsFrom}
            placeholder={"Content Starts From"}
            label={"Content Starts From (Row)"}
            noLabelTransform
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            value={values[fields.contentStartsFrom]}
            // onInput={(e) => {
            //   const inputValue = e.target.value.toString();
            //   if (inputValue.length > 15) {
            //     e.target.value = inputValue.slice(0, 15);
            //   }
            // }}
            validate={(value) => {
              return [undefined, null, ""].includes(value)
                ? "Required"
                : isValidSheetNumber.test(value) === false
                ? "Content Starts From should not be greater than 7 characters"
                : undefined;
            }}
            onKeyPress={(e) => {
              // Prevent the input of decimal point
              if (e.key === "." || (e.key === "-" && e.target.value !== "")) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text/plain");
              if (
                pastedData.includes("e") ||
                pastedData.includes(".") ||
                pastedData.includes("-")
              ) {
                e.preventDefault(); // Prevent the paste action if it exceeds 250 characters
              }
            }}
            component={FieldInput}
            //validate={required}
            isRequired
          />
          {/* {values.mapType == 3 && (
            <>
              <div className="mb-3">
                <p className="p-0 mb-2 ft-12 fw-400">Allow Empty Input File</p>
                <Form.Check
                  type="switch"
                  id={"id"}
                  name={fields.allowEmptyInputFile}
                  checked={values[fields.allowEmptyInputFile]}
                  onChange={() => {
                    setAllowEmptyInputFile(!allowEmptyInputFile);
                    setFieldValue(
                      fields.allowEmptyInputFile,
                      allowEmptyInputFile
                    );
                  }}
                />
              </div>
            </>
          )} */}
        </div>
      </div>
    );
  };

  const fixedLengthComponent = () => {
    return (
      <div style={{ fontSize: "12px" }} className="form-group mb-3">
        <Field
          name={fields.recordLength}
          label={"Record Length"}
          noLabelTransform
          component={FieldInput}
          type="number"
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          //disabled={editable}
          value={values[fields.recordLength]}
          validate={(value) => (value ? null : "Required")}
          isRequired
        />
      </div>
    );
  };

  const getExtensions = (x) => {
    let extensions;
    switch (x) {
      case 1:
        extensions = ".csv";
        break;
      case 2:
        extensions = " .txt, .yaml";
        break;
      case 3:
        extensions = ".xlsx, .xls";
        break;
    }
    return extensions;
  };

  return (
    <div className="mb-5">
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>
        File Information
      </div>

      <Field
        name={fields.fileFormat}
        label={"File format"}
        value={values[fields.fileFormat]}
        options={
          values.mapType == 3 ? PassthorughfileFormatData : fileFormatData
        }
        isRequired
        direction={"bottom"}
        //disabled={isEdit || !isEmpty(get(state, formName, []))}
        //disabled={editable}
        popupContent={
          <SearchableList
            label={"File format"}
            isNotTypeAhead
            options={
              values.mapType == 3 ? PassthorughfileFormatData : fileFormatData
            }
            onSelect={(value) => {
              onChangeFileFormat();
              setFieldValue(fields.fileFormat, value);
            }}
            selectedValue={values[fields.fileFormat]}
          />
        }
        component={FieldDropSide}
      />

      {(() => {
        if (values[fields.fileFormat] === 3) {
          return ExcelComponent();
        }
        if (values[fields.fileFormat] === 1) {
          return CSVComponent();
        }
        if (values[fields.fileFormat] === 2) {
          return fixedLengthComponent();
        }
      })()}

      {values[fields.fileFormat] == 3 && (
        <>
          {/* <div className="Load-def-source-selecttaglabel" >Has Header</div> */}
          <Field
            isRequired
            name={fields.hasHeader}
            label="Has Header"
            size="sm"
            options={yesNoOptions}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            onChange={(value) => {
              setFieldValue(fields.hasHeader, value);
            }}
            selectedValue={values[fields.hasHeader]}
            component={FieldButtonGroup}
          />

          {!values[fields.hasHeader] && (
            <Field
              isRequired
              name={fields.checkForHeaderCountMismatch}
              label="Check for Header Count Mismatch"
              size="sm"
              options={yesNoOptions}
              //disabled={isEdit || !isEmpty(get(state, formName, []))}
              //disabled={editable}
              onChange={(value) => {
                setFieldValue(fields.checkForHeaderCountMismatch, value);
              }}
              selectedValue={values[fields.checkForHeaderCountMismatch]}
              component={FieldButtonGroup}
            />
          )}
          <br />
          <div className="form-group">
            <Field
              type="number"
              name={fields.contentStartsFrom}
              placeholder={"Content Starts From"}
              label={"Content Starts From (Row)"}
              noLabelTransform
              //disabled={isEdit || !isEmpty(get(state, formName, []))}
              //disabled={editable}
              value={values[fields.contentStartsFrom]}
              component={FieldInput}
              //validate={required}
              isRequired
              // onInput={(e) => {
              //   const inputValue = e.target.value.toString();
              //   if (inputValue.length > 7) {
              //     e.target.value = inputValue.slice(0, 7);
              //   }
              // }}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : isValidSheetNumber.test(value) === false
                  ? "Content Starts From should not be greater than 7 characters"
                  : undefined;
              }}
              onKeyPress={(e) => {
                // Prevent the input of decimal point
                if (e.key === "." || (e.key === "-" && e.target.value !== "")) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => {
                const pastedData = e.clipboardData.getData("text/plain");
                if (
                  pastedData.includes("e") ||
                  pastedData.includes(".") ||
                  pastedData.includes("-")
                ) {
                  e.preventDefault(); // Prevent the paste action if it exceeds 250 characters
                }
              }}
            />
            {/* {values.mapType == 3 && (
              <>
                <div className="mb-3">
                  <p className="p-0 mb-2 ft-12 fw-400">
                    Allow Empty Input File
                  </p>

                  <Form.Check
                    type="switch"
                    id={"id"}
                    name={fields.allowEmptyInputFile}
                    checked={values[fields.allowEmptyInputFile]}
                    onChange={() => {
                      setAllowEmptyInputFile(!allowEmptyInputFile);
                      setFieldValue(
                        fields.allowEmptyInputFile,
                        allowEmptyInputFile
                      );
                    }}
                  />
                </div>
              </>
            )} */}
          </div>
        </>
      )}
      {values.mapType == 3 && (
        <Field
          isRequired
          name={fields.requireFtp}
          label="FTP Details"
          size="sm"
          options={yesNoOptions}
          onChange={(value) => {
            setFieldValue(fields.requireFtp, value);
          }}
          selectedValue={values[fields.requireFtp]}
          component={FieldButtonGroup}
        />
      )}

      <FTPDetails
        showFtpDetails={values[fields.requireFtp]}
        required={required}
        fields={fields}
        values={values}
        mapType = {values.mapType}
      />
      {/* {isEdit || !isEmpty(get(state, formName, [])) ? ( */}
      {editable ? (
        <>
          <div>Uploaded File</div>
          <div>
            <UploadComponent
              name={fields.uploadSourceFile}
              values={values}
              clearUploadFile={clearUploadFile}
              setFieldValue={setFieldValue}
              setNewFile={setNewFile}
              clearField={clearField}
              setShowFileName={setShowFileName}
              setFileUploadRequired={setFileUploadRequired}
              setClearField={setClearField}
              label="Upload source file"
              fileExtensions={getExtensions(values[fields.fileFormat])}
            />
          </div>
          {showFileName ? (
            <div>
              {/* {!isEmpty(get(state, "api.data.fileName", []))
                ? get(state, "api.data.fileName", [])
                : values["fileName"]} */}
              {values["fileName"]
                ? values["fileName"]
                : get(state, "api.data.fileName", [])}
            </div>
          ) : null}
          <span style={{ fontSize: "10px", color: "red" }}>
            {fileUploadRequired}
          </span>
        </>
      ) : (
        <div style={{ width: "40rem" }}>
          <div>
            <UploadComponent
              name={fields.uploadSourceFile}
              setFieldValue={setFieldValue}
              label="Upload source file"
              fileExtensions={getExtensions(values[fields.fileFormat])}
            />
          </div>
          <div
            style={{
              fontSize: "0.75rem",
              marginTop: "0rem",
              color: "#ff5050",
            }}
          >
            <span style={{ fontSize: "10px", color: "red" }}>
              {fileUploadRequired}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default FileInfo;
